import cx from 'clsx'
import { Input, InputNumber, Checkbox, DatePicker, TimePicker, Select, Radio } from 'antd'
import { defaultTo } from 'lodash'

function Component(props) {
  const { question = {}, layout = 'vertical', color } = props

  if (question.questionType === 'Textarea') {
    return (
      <Input.TextArea
        key={question.defaultText}
        defaultValue={question.defaultText}
        placeholder={question.placeholderText}
        rows={question.height}
      />
    )
  }

  if (question.questionType === 'NumberInput') {
    return (
      <InputNumber
        key={question.defaultNumber}
        defaultValue={question.defaultNumber}
        min={defaultTo(question.minValue, undefined)}
        max={defaultTo(question.maxValue, undefined)}
        step={1.0 / Math.pow(10, question.decimalPlaces)}
        className="w-full"
      />
    )
  }

  if (question.questionType === 'Dropdown') {
    return (
      <Select
        key={question.defaultText}
        defaultValue={question.defaultText ? question.defaultText : undefined}
        placeholder={question.placeholderText}
        allowClear={!question.required}
        className="w-full"
      >
        {(question?.formQuestionOptions ?? []).map((each) => (
          <Select.Option key={each.name} value={each.name}>
            {each.name}
          </Select.Option>
        ))}
      </Select>
    )
  }

  if (question.questionType === 'Date') {
    return <DatePicker className="w-full min-w-full" placeholder={question.placeholderText} />
  }

  if (question.questionType === 'DateTime') {
    return <DatePicker className="w-full min-w-full" placeholder={question.placeholderText} showTime />
  }

  if (question.questionType === 'Time') {
    return (
      <TimePicker
        className="w-full min-w-full"
        placeholder={question.placeholderText}
        format="h:mm A"
        use12Hours
      />
    )
  }

  if (question.questionType === 'Checkbox') {
    return (
      <Checkbox key={question.defaultBoolean} defaultChecked={question.defaultBoolean}>
        {layout === 'vertical' ? (
          <span className={cx({ 'ant-form-item-required': question.required })} style={{ color }}>
            {question.text}
          </span>
        ) : null}
      </Checkbox>
    )
  }

  if (question.questionType === 'SingleSelection') {
    return (
      <Radio.Group
        key={question.defaultText}
        defaultValue={question.defaultText ? question.defaultText : undefined}
        className={cx({ 'tofino-radio-group-vertical': layout === 'horizontal' })}
      >
        {(question?.formQuestionOptions ?? []).map((each) => (
          <Radio key={each.name} value={each.name}>
            <span style={{ color }}>{each.name}</span>
          </Radio>
        ))}
      </Radio.Group>
    )
  }

  if (question.questionType === 'MultipleSelection') {
    return (
      <Checkbox.Group className={cx({ 'tofino-checkbox-group-vertical': layout === 'horizontal' })}>
        {(question?.formQuestionOptions ?? []).map((each) => (
          <Checkbox key={each.name} value={each.name}>
            <span style={{ color }}>{each.name}</span>
          </Checkbox>
        ))}
      </Checkbox.Group>
    )
  }

  if (question.questionType === 'Hyperlink') {
    return (
      <a
        style={{
          color: question.overrideSectionColor ? question.foregroundColor : '#0080FF',
          backgroundColor: question.overrideSectionColor ? question.backgroundColor : 'transparent',
          fontFamily: question.fontName ? question.fontName : undefined,
          fontSize: Math.max(question.fontSize, 8),
          fontWeight: question.bold ? 500 : 'normal',
          fontStyle: question.italic ? 'italic' : 'normal',
          textDecoration: question.underline ? 'underline' : 'none',
          ...(question.overrideSectionColor
            ? {
                '&:hover': {
                  color: question.foregroundColor,
                  opacity: 0.5,
                },
              }
            : {}),
        }}
        href={question.questionOption}
        target="_blank"
        rel="noopener noreferrer"
      >
        {question.text}
      </a>
    )
  }

  if (question.questionType === 'Paragraph') {
    return (
      <div
        style={{
          color: question.overrideSectionColor ? question.foregroundColor : color,
          backgroundColor: question.overrideSectionColor ? question.backgroundColor : undefined,
          fontFamily: question.fontName ? question.fontName : undefined,
          fontSize: Math.max(question.fontSize, 8),
          fontWeight: question.bold ? 500 : 'normal',
          fontStyle: question.italic ? 'italic' : 'normal',
          textDecoration: question.underline ? 'underline' : 'none',
          whiteSpace: 'pre-line',
        }}
      >
        {question.text}
      </div>
    )
  }

  return (
    <Input
      key={question.defaultText}
      defaultValue={question.defaultText ? question.defaultText : undefined}
      placeholder={question.placeholderText}
    />
  )
}

export default Component
